import { render, staticRenderFns } from "./Soc.vue?vue&type=template&id=1cdaecd4"
import script from "./Soc.vue?vue&type=script&lang=js"
export * from "./Soc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports